import { connect, useSelector } from "react-redux";
import { Modal } from "bootstrap";
import AppBaseComponent from '../../../../components/AppBaseComponent';
import HttpAPICall from "../../../../services/HttpAPICall";
import Loader from "../../../../components/ui/Loader/Loader";
import tapIcon from "../../../../services/TapIcon";
import Ax from "../../../../components/hoc/Ax";
import TapSelect from "../../../../components/ui/TapSelect";
import { toast } from "react-toastify";
import React, { useState, useEffect, useRef } from "react";
import swal from "sweetalert";
import Status from "../../../../components/ui/Status";
import { SketchPicker } from 'react-color';
import TapApiUrls, { INVENTORY_API_BASE_URL_2 } from "../../../../services/TapApiUrls";

const DealSubStatus = (props) => {
    const permissions = useSelector(state => state.app.acl_info && state.app.acl_info.permissions && state.app.acl_info.permissions.length > 0 ? state.app.acl_info.permissions : [])
    const access_token = useSelector(state => state.auth.access_token);
    const initRentalSubStatusForm = {
        name: "",
        status_id: null,
        color: '#2A974E',
        notes: ''
    };

    const [listingLoading, setListingLoading] = useState(false);
    const [subStatusListing, setSubStatusListing] = useState([]);
    const [editFormLoading, setEditFormLoading] = useState(false);
    const [editFormSubmiting, setEditFormSubmiting] = useState(false);
    const [allStatus, setAllStatus] = useState([]);
    const [rentalSubStatusForm, setRentalSubStatusForm] = useState({ ...initRentalSubStatusForm });
    const [allColorCodes, setAllColorCodes] = useState([]);
    const [formDataLoaded, setFormDataLoaded] = useState(false);
    const [displayColorPicker, setDisplayColorPicker] = useState(false);
    const [editSubStatus, setEditSubStatus] = useState(false);

    const editRentalSubStatusModalRef = useRef(null);
    let editRentalSubStatusModal = null;

    useEffect(() => {
        fetchSubStatusListing();
        editRentalSubStatusModal = new Modal(document.getElementById('editRentalSubStatusModal'), { keyboard: false, backdrop: false });
        editRentalSubStatusModalRef.current = editRentalSubStatusModal;
    }, []);

    const fetchFormData = () => {
        setEditFormLoading(true);
        HttpAPICall.withAthorization('GET', INVENTORY_API_BASE_URL_2 + '/deal_sub_status/form_data', access_token, {}, {}, (resp) => {
            let respData = resp.data.data;
            setAllStatus(respData.status && respData.status.length > 0 ? respData.status.map(u => { return { value: u.id, label: u.name }; }) : []);
            setAllColorCodes(respData.colors && respData.colors.length > 0 ? respData.colors : []);
            setFormDataLoaded(true);
        }).then(() => setEditFormLoading(false));
    };

    const fetchSubStatusListing = () => {
        setListingLoading(true);
        HttpAPICall.withAthorization('GET', INVENTORY_API_BASE_URL_2 + '/deal_sub_status/list', access_token, {}, {}, (resp) => {
            setSubStatusListing(resp.data.data);
        }).then(() => setListingLoading(false));
    };

    const editRentalSubStatusModalInit = (status = null) => {

        if (editRentalSubStatusModalRef.current) {
            editRentalSubStatusModalRef.current.show();
        }

        if (!formDataLoaded) {
            fetchFormData();
        }

        if (status) {
            
            setRentalSubStatusForm({
                ...initRentalSubStatusForm,
                sequence: status.sequence,
                name: status.name,
                color: status.color,
                status_id: status.status ? status.status.id : null,
                notes: status.notes,
                id: status.id,
            });
            setEditSubStatus(true);
        } else {
            setEditSubStatus(false);
            setRentalSubStatusForm({ ...initRentalSubStatusForm });
        }
    };

    const handleColorChange = (colorHex) => {
        if (colorHex) {
            setRentalSubStatusForm({ ...rentalSubStatusForm, color: colorHex });
        }
    };

    const handleClick = () => {
        setDisplayColorPicker(!displayColorPicker);
    };

    const handleClose = () => {
        setDisplayColorPicker(false);
    };

    const formInputHandler = (e, formType) => {
        const { name, value } = e.target;
        setRentalSubStatusForm({
            ...rentalSubStatusForm,
            [name]: value
        });
    };

    const tapSelectChange = (selectedOption, formType, fieldName) => {
        const selectedValue = selectedOption ? selectedOption.value : null;
        setRentalSubStatusForm({
            ...rentalSubStatusForm,
            [fieldName]: selectedValue
        });
    };

    const submitRentalSubStatusForm = (e) => {
        e.preventDefault();
        let frmData = { ...rentalSubStatusForm };

        if (editSubStatus) {
            setEditFormSubmiting(true);
            HttpAPICall.withAthorization('PUT', INVENTORY_API_BASE_URL_2 + '/deal_sub_status/update', access_token, {}, { ...frmData }, (response) => {
                toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
                if (editRentalSubStatusModalRef.current) {
                    editRentalSubStatusModalRef.current.hide();
                }
                setRentalSubStatusForm({ ...initRentalSubStatusForm });
                fetchSubStatusListing();
            }).then(() => setEditFormSubmiting(false));
        } else {
            setEditFormSubmiting(true);
            HttpAPICall.withAthorization('POST', INVENTORY_API_BASE_URL_2 + '/deal_sub_status/add', access_token, {}, { ...frmData }, (response) => {
                toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
                if (editRentalSubStatusModalRef.current) {
                    editRentalSubStatusModalRef.current.hide();
                }
                setRentalSubStatusForm({ ...initRentalSubStatusForm });
                fetchSubStatusListing();
            }).then(() => setEditFormSubmiting(false));
        }
    };

    const deleteRentalStatus = (id) => {
        swal({
            title: "Delete",
            text: "This action cannot be reversed, Are you sure you want to proceed?",
            icon: "warning",
            dangerMode: true,
            buttons: ["No", "Yes"],
        }).then(willDelete => {
            if (willDelete) {
                HttpAPICall.withAthorization('DELETE', INVENTORY_API_BASE_URL_2 + '/deal_sub_status/delete/' + id, access_token, {}, {}, (response) => {
                    toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
                    fetchSubStatusListing();
                });
            }
        });
    };

    const dealSubStatusFormModalJsx = () => {
        const popover = {
            position: 'absolute',
            zIndex: '2',
        };
        const cover = {
            position: 'fixed',
            top: '0px',
            right: '0px',
            bottom: '0px',
            left: '0px',
        };

        return (
            <div className="modal fade" id="editRentalSubStatusModal" tabIndex="-1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="addAssetModalLabel">{editSubStatus ? "Edit" : "Add"} Deal Sub-Status</h5>
                        </div>
                        <form onSubmit={submitRentalSubStatusForm}>
                            {editFormLoading
                                ? <Loader />
                                : (<Ax>
                                    <div className="modal-body">
                                        <div className="row mb-2 align-items-center">
                                            <div className="col-sm-2 ">
                                                <label className="col-form-label require">Sequence</label>
                                            </div>
                                            <div className="col-sm-6">
                                                <input type="number"
                                                    onChange={(e) => formInputHandler(e, "rentalSubStatusForm")}
                                                    className="form-control form-control-sm"
                                                    name="sequence"
                                                    step="any"
                                                    autoComplete="off"
                                                    required='true'
                                                    value={rentalSubStatusForm.sequence || ''}
                                                    placeholder="Enter Status Sequence" />
                                            </div>
                                        </div>
                                        <div className="row mb-2 align-items-center">
                                            <div className="col-sm-2 ">
                                                <label className="col-form-label require">Status</label>
                                            </div>
                                            <div className="col-sm-6">
                                                <TapSelect
                                                    isSearchable={true}
                                                    isClearable={true}
                                                    placeholder="Select Status"
                                                    options={allStatus}
                                                    value={allStatus.find(su => rentalSubStatusForm.status_id == su.value)}
                                                    changeEvent={(selectedOption) => tapSelectChange(selectedOption, 'rentalSubStatusForm', 'status_id')}
                                                    containerHeight="30px"
                                                    fontSize="93%"
                                                    autoComplete="off"
                                                />
                                            </div>
                                        </div>
                                        <div className="row mb-2 align-items-center">
                                            <div className="col-sm-2 ">
                                                <label className="col-form-label require">Sub Status </label>
                                            </div>
                                            <div className="col-sm-6">
                                                <input type="text"
                                                    onChange={(e) => formInputHandler(e, "rentalSubStatusForm")}
                                                    className="form-control form-control-sm"
                                                    name="name"
                                                    autoComplete="off"
                                                    required='true'
                                                    value={rentalSubStatusForm.name}
                                                    placeholder="Enter Status Name" />
                                            </div>
                                        </div>

                                        <div className="row mb-2 align-items-center">
                                            <div className="col-sm-2 ">
                                                <label className="col-form-label require">Color Code</label>
                                            </div>
                                            <div className="col-sm-4">
                                                <div className="input-group input-group-sm">
                                                    <span className="input-group-text px-4 me-3"
                                                        onClick={handleClick}
                                                        style={{ background: rentalSubStatusForm.color }}></span>
                                                    <input
                                                        name="color"
                                                        type="text"
                                                        className="form-control form-control-sm"
                                                        value={rentalSubStatusForm.color}
                                                        autoComplete="off"
                                                        onChange={(e) => formInputHandler(e, "rentalSubStatusForm")}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-sm-3">
                                                <button type="button" onClick={handleClick} className="btn btn-link text-sm">Pick Color</button>
                                                {displayColorPicker ? <div style={popover}>
                                                    <div style={cover} onClick={handleClose} />
                                                    <SketchPicker
                                                        color={rentalSubStatusForm.color}
                                                        presetColors={allColorCodes}
                                                        onChangeComplete={(color) => handleColorChange(color.hex)} />
                                                </div> : null}
                                            </div>
                                        </div>

                                        <div className="row mb-2 align-items-center">
                                            <div className="col-sm-2 ">
                                                <label className="col-form-label">Notes</label>
                                            </div>
                                            <div className="col-sm-6">
                                                <textarea
                                                    name="notes"
                                                    value={rentalSubStatusForm.notes}
                                                    onChange={(e) => formInputHandler(e, 'rentalSubStatusForm')}
                                                    className="form-control"
                                                    style={{ height: "40px" }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </Ax>)}
                            <div className="modal-footer">
                                <button type="button" disabled={editFormSubmiting} className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                <button type="submit" disabled={editFormSubmiting} className="btn btn-primary">
                                    Save {editFormSubmiting ? (<tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin" />) : null}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <Ax>
            <div className="tab_content_wrapper mt-2 mb-2">
                <span className="content_heading">Sub Status for Deals</span>
                <div className="float-end">
                    <button
                        className="btn btn-primary"
                        disabled={!permissions.includes('deal_manage_status')}
                        onClick={() => editRentalSubStatusModalInit()}
                    >
                        Add Sub-Status
                    </button>
                </div>
            </div>
            <table className="table table-hover table-bordered my-3">
                <thead>
                    <tr className="table-secondary">
                        <th scope="col" style={{ width: "15%" }}>Status</th>
                        <th scope="col" style={{ width: "15%" }}>Sub-Status</th>
                        <th scope="col" style={{ width: "15%" }} className="text-center">Sequence</th>

                        <th scope="col" style={{ width: "15%" }} className="text-center">Color Code</th>
                        <th scope="col" style={{ width: "20%" }}>Notes</th>
                        <th scope="col" style={{ width: "10%" }} className="text-center">Action</th>
                    </tr>
                </thead>
                <tbody>
                    {listingLoading
                        ? (<tr><td colSpan="6"><Loader /></td></tr>)
                        : (subStatusListing.length > 0
                            ? (subStatusListing.map((status, k) => {
                                return (
                                    <tr key={k}>
                                        <td className="text-capitalize">{status.status?.name}</td>
                                        <td className="text-capitalize">{status.name ? status.name : "-"}</td>
                                        <td className="text-center">{status.sequence}</td>
                                        <td className="text-center"><Status color={status.color}></Status></td>
                                        <td>{status.notes ? status.notes : "-"}</td>
                                        <td className='text-center'>
                                            <tapIcon.imageIcon icon={tapIcon.ListActionIcon} alt="action-icon" className="img-fluid px-3" data-bs-toggle="dropdown" href="#"
                                                role="button" aria-expanded="false" />
                                            <ul className="dropdown-menu" style={{ cursor: "pointer" }}>
                                                <li>
                                                    <button 
                                                        className={[status.can_edit == false || (!permissions.includes('deal_manage_status')) ? "disabled dropdown-item" : "dropdown-item"].join(', ')}
                                                        type="button"
                                                        onClick={() => editRentalSubStatusModalInit(status)}
                                                    >
                                                        Edit
                                                    </button>
                                                </li>
                                                {/* <li>
                                                    <a
                                                        className={[status.can_delete == false || (!permissions.includes('deal_manage_status')) ? "disabled dropdown-item" : "dropdown-item"].join(', ')}
                                                        role="button"
                                                        onClick={() => deleteRentalStatus(status.id)}
                                                    >
                                                        Delete
                                                    </a>
                                                </li> */}
                                            </ul>
                                        </td>
                                    </tr>
                                );
                            }))
                            : (<tr><td colSpan="6" className="text-center">No Records</td></tr>)
                        )
                    }
                </tbody>
            </table>
            {dealSubStatusFormModalJsx()}
        </Ax>
    );
};

export default (DealSubStatus);